import { render, staticRenderFns } from "./MobileMessageLayout.vue?vue&type=template&id=b6529116&"
import script from "./MobileMessageLayout.vue?vue&type=script&lang=ts&"
export * from "./MobileMessageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./MobileMessageLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports